var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chart.color)?_c('div',{class:'bizcomp-currency-chart bizcomp ' + _vm.className},[_c('comp-title',{attrs:{"title":_vm.title}}),_c('chart',{attrs:{"option":_vm.chart,"char-cate":_vm.charCate,"ref-v":'currency'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }